import React from 'react';

import { BlogWrapper } from './styles';

function Blog() {
    return (
        <BlogWrapper>
            <h1>Latest from our blog</h1>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Laudantium, placeat beatae ipsa numquam odio magni blanditiis voluptate unde corrupti maxime.</p>

            <section>
                <div>
                    <img src="https://www.starpik.com/wp-content/uploads/_sz/183077_small.jpg" alt="" />
                    <div className="description">
                        <div>
                            <h1>25</h1>
                            <span>AUG</span>
                        </div>
                        <div>
                            <h2>Brilliant minds.</h2>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempore maxime officia nostrum ullam dolore nulla dignissimos pariatur natus earum doloribus!</p>
                            <h4>5 Comments</h4>
                        </div>
                    </div>
                </div>
                <div>
                    <img src="https://static.vecteezy.com/system/resources/thumbnails/000/269/054/small/eporokdd9387.jpg" alt="" />
                    <div className="description">
                        <div>
                            <h1>25</h1>
                            <span>AUG</span>
                        </div>
                        <div>
                            <h2>Brilliant minds.</h2>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempore maxime officia nostrum ullam dolore nulla dignissimos pariatur natus earum doloribus!</p>
                            <h4>2 Comments</h4>
                        </div>
                    </div>
                </div>
                <div>
                    <img src="https://www.starpik.com/wp-content/uploads/_sz/174453_small.jpg" alt="" />
                    <div className="description">
                        <div>
                            <h1>25</h1>
                            <span>AUG</span>
                        </div>
                        <div>
                            <h2>Brilliant minds.</h2>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempore maxime officia nostrum ullam dolore nulla dignissimos pariatur natus earum doloribus!</p>
                            <h4>No Comments</h4>
                        </div>
                    </div>
                </div>
            </section>
        </BlogWrapper>
    );
}

export default Blog;